export const DEMANDBASE_PROPERTIES = Object.freeze([
  {
    label: 'Audience',
    value: 'audience',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Company Name',
    value: 'companyName',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Industry',
    value: 'industry',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Sub Industry',
    value: 'subIndustry',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Employee Count',
    value: 'employeeCount',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Employee Range',
    value: 'employeeRange',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Marketing Alias',
    value: 'marketingAlias',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Annual Sales',
    value: 'annualSales',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Revenue Range',
    value: 'revenueRange',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'City',
    value: 'city',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'State',
    value: 'state',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Country Code',
    value: 'countryCode',
    source: 'demandbase',
    hasNoFallback: false,
  },
  {
    label: 'Country Name',
    value: 'countryName',
    source: 'demandbase',
    hasNoFallback: false,
  },
])
